// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__cVV_0","footerText":"styles_footerText__2W3AC","export":"styles_export__2pokr","exportButtons":"styles_exportButtons__4oEOz"};